import { render } from "./ChiCkenlegs.vue?vue&type=template&id=7560d5da"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/ChiCkenlegs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7560d5da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7560d5da', __exports__)) {
    api.reload('7560d5da', __exports__)
  }
  
  module.hot.accept("./ChiCkenlegs.vue?vue&type=template&id=7560d5da", () => {
    api.rerender('7560d5da', render)
  })

}


export default __exports__